<template>
  <div
    class="popup_wrap"
    style="width:750px;"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.MYIN010G010.037') }}</h1>
      <div class="content_box">
        <!-- <h2 class="content_title">{{ setUploadTitle() }}</h2> -->
        <!-- <p class="color_red font_12 mb5" v-if="parentInfo.type === 'F'">{{ $t('msg.NEWB020P030.012') }}</p> -->
        <component
          v-if="customComponent"
          :is="customComponent"
          ref="dextupload"
          id="dextupload1"
          width="100%"
          height="200px"
          :file-info="uploadFileList"
          :category-info="[]"
        />
      </div>
      <div class="mt10 text_center">
        <a
          class="button blue lg"
          href="#"
          @click.prevent="insertFile()"
        >{{ $t('msg.NEWB020P030.004') }}</a><!-- 저장 -->
      </div>
    </div>
  </div>
</template>

<script>

import DEXT5Upload from '@/components/DEXT5Upload'
import member from '@/api/rest/user/member'

export default {
  name: 'BusinessFilesPop',
  components: { DEXT5Upload },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          userId: ''
        }
      }
    }
  },
  data () {
    return {
      isCategory: true,

      msdsList: [],

      params: {
        userId: this.parentInfo.userId,
        // 첨부파일 리스트(실제 입력)
        uploadFileInfos: [],
        uploadBusinessFileInfos: []
      },

      // Dext Uploader와 연결되어 있는 배열
      uploadFileList: [],
      orgUploadFileList: [],
      customComponent: null
    }
  },
  computed: {
  },
  created () {
    //setTimeout(() => this.initPopup(), 1000)
    this.initPopup()
  },
  methods: {
    async initPopup () {
      this.customComponent = null

        if (this.parentInfo.userId !== '') {
          await this.getBusinessFileList()
        }
      this.orgUploadFileList = this.uploadFileList.slice()

      this.customComponent = 'DEXT5Upload'
    },
    async getBusinessFileList () {
      await member.getFileList(this.parentInfo.userId).then(response => {
        const resp = response.data.fileList
        for (let i = 0; i < resp.length; i++) {
          this.uploadFileList.push({
            guid: i + 1,
            originalName: resp[i].fileNm,
            size: resp[i].fileSz,
            fileId: resp[i].fileId,
            status: 'complete'
          })
        }
        console.log(this.uploadFileList)

        if (this.parentInfo.fileInfos != null && this.parentInfo.fileInfos.length > 0) {
          this.uploadFileList = this.parentInfo.fileInfos
        }
      })
    },
    // 저장 or 수정
    async insertFile () {
      console.log(this.uploadFileList)
      const TH = this
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.NEWB020P030.008'), useConfirmBtn: true })) {
          await TH.onConfirmInsert()
        }
    },
    // 저장 Confirm '확인' 클릭 시 콜백 메소드
    async onConfirmInsert () {
      console.log(this.uploadFileList)

      // 실제 입력할 파일리스트를 담는다.
      this.params.uploadBusinessFileInfos = this.uploadFileList

      // 새로 추가된 파일은 json에 'newFlag' 값을 부여해준다. ('new'는 뒷단에서 예약어 이므로 새로 추가)
      this.params.uploadBusinessFileInfos.map((item) => (item.newFlag = item.new))

      // 기존 파일은 fileId에 다운로드 링크가 들어 있어서
      // 뒷단에서 Data binding 할 때, 오류가 나서 값을 비워줘야 한다.
      // this.params.uploadEtcFileInfos.forEach((element, idx) => {
      //   if (element.newFlag === undefined || element.newFlag === '') {
      //     element.fileId = ''
      //   }

      //   // element.fileSeq = (idx + 1)
      // })

      this.$emit('selectFunc', this.params.uploadBusinessFileInfos)
    }
  }
}
</script>
